/**
* CorrelationVectorPlugin.ts
* @author Ram Thiru (ramthi) and Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import { __extends } from "tslib";
import { BaseTelemetryPlugin, _throwInternal, setProcessTelemetryTimings } from "@microsoft/applicationinsights-core-js";
import { Cv } from "./Cv";
var CorrelationVectorPlugin = /** @class */ (function (_super) {
    __extends(CorrelationVectorPlugin, _super);
    function CorrelationVectorPlugin(cvInitialValue) {
        var _this = _super.call(this) || this;
        _this.identifier = "CorrelationVectorPlugin";
        _this.priority = 159;
        _this.version = '4.4.1';
        _this._cvInitialValue = cvInitialValue;
        // Default cV, could be used before initialization of the SDK
        _this._cv = _this._cvInitialValue ? new Cv(_this._cvInitialValue) : new Cv();
        return _this;
    }
    /**
     * Initialize the Correlation Vector plugin
     * @param config - The plugin configuration.
     * @param core - Core reference.
     * @param extensions - All other extensions
     */
    CorrelationVectorPlugin.prototype.initialize = function (coreConfig, core, extensions) {
        _super.prototype.initialize.call(this, coreConfig, core, extensions);
    };
    /**
    * Process a given event.
    * @param event - The event to be hydrated with CV.
     * @param itemCtx - This is the context for the current request, ITelemetryPlugin instances
     * can optionally use this to access the current core instance or define / pass additional information
     * to later plugins (vs appending items to the telemetry item)
    */
    CorrelationVectorPlugin.prototype.processTelemetry = function (event, itemCtx) {
        setProcessTelemetryTimings(event, this.identifier);
        event.ext = event.ext || {};
        event.ext["mscv"] = event.ext["mscv"] || {};
        // If cV is present do not override
        if (!event.ext["mscv"]["cV"]) {
            if (this._cv && this._cv.isInit()) {
                event.ext["mscv"]["cV"] = this._cv.getValue();
            }
        }
        this.processNext(event, itemCtx);
    };
    /**
    * Get cV instance
    */
    CorrelationVectorPlugin.prototype.getCv = function () {
        if (!this._cv) {
            _throwInternal(this.diagLog(), 2 /* eLoggingSeverity.WARNING */, 513 /* _eExtendedInternalMessageId.FailedToInitializeCorrelationVector */, "Correlation Vector has not been initialized.");
        }
        return this._cv;
    };
    return CorrelationVectorPlugin;
}(BaseTelemetryPlugin));
export { CorrelationVectorPlugin };
//# sourceMappingURL=CorrelationVectorPlugin.js.map